import { createBrowserRouter, Navigate } from "react-router-dom";
import AnalistaRoute from "./components/AnalistaRoute";
import AppLayout from "./components/AppLayout";
import SecretarioRoute from "./components/SecretarioRoute";
import SecretarioOuAnalistaRoute from "./components/SecretarioOuAnalistaRoute";
import PrivateRoute from "./components/PrivateRoute";
import CadastroDados from "./pages/analista/CadastroDados";
import AdicionarTipoLicenca from "./pages/analista/AdicionarTipoLicenca";
import AdicionarChecklist from "./pages/analista/AdicionarChecklist";
import CadastroPDFLayout from "./pages/analista/CadastroPDFLayout";
import AutoDeInfracaoAnalista from "./pages/analista/AutoDeInfracaoAnalista";
import TaxasChecklist from "./pages/analista/TaxasChecklist";
import Relatorios from "./pages/analista/Relatorios";
import ParecerTecnico from "./pages/analista/ParecerTecnico";
import Login from "./pages/auth/Login";
import ConfirmEmail from "./pages/auth/ConfirmEmail";
import Registro from "./pages/Registro";
import AnalystDashboard from "./pages/dashboard/AnalystDashboard";
import SecretarioDashboard from "./pages/dashboard/SecretarioDashboard";
import UserDashboard from "./pages/dashboard/UserDashboard";
import DetalheSolicitacao from "./pages/DetalheSolicitacao";
import DetalheSolicitacaoAnalista from "./pages/analista/DetalheSolicitacaoAnalista";
import DetalheSolicitacaoSecretario from "./pages/secretario/DetalheSolicitacaoSecretario";
import EmitirLicenca from "./pages/EmitirLicenca";
import EmitirAutorizacao from "./pages/EmitirAutorizacao";
import AssinarLicenca from "./pages/AssinarLicenca";
import AssinarIsencao from "./pages/AssinarIsencao";
import Home from "./pages/Home";
import Publicacoes from "./pages/Publicacoes";
import PublicacaoDetalhe from "./pages/PublicacaoDetalhe";
import AlterarDados from "./pages/AlterarDadosInteressado";
import AlterarDadosPessoaJuridica from "./pages/AlterarDadosPessoaJuridica";
// Cadastro/uso de Responsável Técnico desativado
// import AlterarDadosResponsavelTecnico from "./pages/AlterarDadosResponsavelTecnico";
import AutoInfracao from "./pages/interessado/AutoInfracao";
import ConsumidorFlorestal from "./pages/interessado/ConsumidorFlorestal";
import DetalhesEmpreendimento from "./pages/interessado/DetalhesEmpreendimento";
import Empreendimentos from "./pages/Empreendimentos";
import Requerimentos from "./pages/interessado/Requerimentos";
import Declaracoes from "./pages/interessado/Declaracoes";
import CdnslamPage from "./pages/interessado/CdnslamPage";
import IsencaoLicenciamentoPage from "./pages/interessado/IsencaoLicenciamentoPage";
import MinhasSolicitacoes from "./pages/MinhasSolicitacoes";
import NovaSolicitacao from "./pages/NovaSolicitacao";
import MinhasAutorizacoes from "./pages/MinhasAutorizacoes";
import NovaAutorizacao from "./pages/NovaAutorizacao";
import DetalheAutorizacao from "./pages/DetalheAutorizacao";
import AdicionarChecklistAutorizacao from "./pages/analista/AdicionarChecklistAutorizacao";
import CriarAutorizacaoIndependente from "./pages/analista/CriarAutorizacaoIndependente";
import Perfil from "./pages/Perfil";
import AlterarSenha from "./pages/AlterarSenha";
// import RegistroResponsavelTecnico from "./pages/RegistroResponsavelTecnico";
import Contato from "./pages/Contato";
import TermosDeUso from "./pages/TermosDeUso";
// import MinhasLicencasResponsavelTecnico from "./pages/responsavel-tecnico/MinhasLicencas";
import Checklist from "./pages/simulador/Checklist";
import TaxasLaboratorio from "./pages/simulador/TaxasLaboratorio";
import TaxasLicenciamento from "./pages/simulador/TaxasLicenciamento";
import ValidarDocumento from "./pages/ValidarDocumento";

const Layout = AppLayout;

const routes = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/confirm-email",
        element: <ConfirmEmail />,
      },
      {
        path: "/termos-de-uso",
        element: <TermosDeUso />,
      },
      {
        path: "/contato",
        element: <Contato />,
      },
      {
        path: "/publicacoes",
        element: <Publicacoes />,
      },
      {
        path: "/publicacoes/:id",
        element: <PublicacaoDetalhe />,
      },
      {
        path: "/validar/licenca/:id",
        element: <ValidarDocumento tipo="licenca" />,
      },
      {
        path: "/validar/autorizacao/:id",
        element: <ValidarDocumento tipo="autorizacao" />,
      },
      {
        path: "/validar/cdnslam/:id",
        element: <ValidarDocumento tipo="cdnslam" />,
      },
      {
        path: "/validar/isencao/:id",
        element: <ValidarDocumento tipo="isencao" />,
      },
      {
        path: "/registro",
        element: <Registro />,
      },
      // {
      //   path: "/Registro-responsavel-tecnico",
      //   element: <RegistroResponsavelTecnico />,
      // },
      {
        path: "/dashboard",
        element: (
          <PrivateRoute>
            <UserDashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/nova-solicitacao",
        element: (
          <PrivateRoute>
            <NovaSolicitacao />
          </PrivateRoute>
        ),
      },
      {
        path: "/minhas-solicitacoes",
        element: (
          <PrivateRoute>
            <MinhasSolicitacoes />
          </PrivateRoute>
        ),
      },
      {
        path: "/solicitacao/:id",
        element: (
          <PrivateRoute>
            <DetalheSolicitacao />
          </PrivateRoute>
        ),
      },
      {
        path: "/solicitacao/:id/emitir",
        element: (
          <AnalistaRoute>
            <EmitirLicenca />
          </AnalistaRoute>
        ),
      },
      {
        path: "/solicitacao/:id/regenerar",
        element: (
          <AnalistaRoute>
            <EmitirLicenca modoRegeneracao />
          </AnalistaRoute>
        ),
      },
      {
        path: "/solicitacao/:id/assinar",
        element: (
          <SecretarioRoute>
            <AssinarLicenca />
          </SecretarioRoute>
        ),
      },
      {
        path: "/isencao/:id/assinar",
        element: (
          <SecretarioRoute>
            <AssinarIsencao />
          </SecretarioRoute>
        ),
      },
      {
        path: "/simulador/checklist",
        element: (
          <PrivateRoute>
            <Checklist />
          </PrivateRoute>
        ),
      },
      {
        path: "/simulador/taxas-laboratorio",
        element: (
          <PrivateRoute>
            <TaxasLaboratorio />
          </PrivateRoute>
        ),
      },
      {
        path: "/analista/taxas-licenciamento",
        element: (
          <AnalistaRoute>
            <TaxasLicenciamento />
          </AnalistaRoute>
        ),
      },
      {
        path: "/perfil",
        element: (
          <PrivateRoute>
            <Perfil />
          </PrivateRoute>
        ),
      },
      {
        path: "/perfil/alterar-senha",
        element: (
          <PrivateRoute>
            <AlterarSenha />
          </PrivateRoute>
        ),
      },
      // {
      //   path: "/responsavel-tecnico/licencas",
      //   element: (
      //     <PrivateRoute>
      //       <MinhasLicencasResponsavelTecnico />
      //     </PrivateRoute>
      //   ),
      // },
      {
        path: "/interessado/alterar-dados",
        element: (
          <PrivateRoute>
            <AlterarDados />
          </PrivateRoute>
        ),
      },
      {
        path: "/perfil/empresa/editar",
        element: (
          <PrivateRoute>
            <AlterarDadosPessoaJuridica />
          </PrivateRoute>
        ),
      },
      // {
      //   path: "/alterar-dados-responsavel-tecnico",
      //   element: (
      //     <PrivateRoute>
      //       <AlterarDadosResponsavelTecnico />
      //     </PrivateRoute>
      //   ),
      // },
      {
        path: "/interessado/auto-infracao",
        element: (
          <PrivateRoute>
            <AutoInfracao />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/consumidor-florestal",
        element: (
          <PrivateRoute>
            <ConsumidorFlorestal />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/empreendimentos",
        element: (
          <PrivateRoute>
            <Empreendimentos />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/requerimentos",
        element: (
          <PrivateRoute>
            <Requerimentos />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/declaracoes",
        element: (
          <PrivateRoute>
            <Declaracoes />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/declaracoes/cdnsla",
        element: (
          <PrivateRoute>
            <CdnslamPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/declaracoes/isencao",
        element: (
          <PrivateRoute>
            <IsencaoLicenciamentoPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/protocolos",
        element: (
          <PrivateRoute>
            <Navigate to="/dashboard" replace />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/declaracoes/protocolo",
        element: (
          <PrivateRoute>
            <Navigate to="/dashboard" replace />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/declaracoes/protocolo/novo",
        element: (
          <PrivateRoute>
            <Navigate to="/nova-solicitacao" replace />
          </PrivateRoute>
        ),
      },
      {
        path: "/interessado/declaracoes/protocolo/confirmar",
        element: (
          <PrivateRoute>
            <Navigate to="/nova-solicitacao" replace />
          </PrivateRoute>
        ),
      },
      {
        path: "/empreendimento/:id",
        element: (
          <PrivateRoute>
            <DetalhesEmpreendimento />
          </PrivateRoute>
        ),
      },
      {
        path: "/dashboard-analista",
        element: (
          <AnalistaRoute>
            <AnalystDashboard />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/dashboard",
        element: (
          <AnalistaRoute>
            <AnalystDashboard />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/solicitacao/:id",
        element: (
          <AnalistaRoute>
            <DetalheSolicitacaoAnalista />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/relatorios",
        element: (
          <AnalistaRoute>
            <Relatorios />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/parecer-tecnico",
        element: (
          <AnalistaRoute>
            <ParecerTecnico />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/cadastro-dados",
        element: (
          <AnalistaRoute>
            <CadastroDados />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/cadastro-dados/tipos-licenca",
        element: (
          <AnalistaRoute>
            <AdicionarTipoLicenca />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/cadastro-dados/checklist",
        element: (
          <AnalistaRoute>
            <AdicionarChecklist />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/cadastro-dados/pdf-layout",
        element: (
          <AnalistaRoute>
            <CadastroPDFLayout />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/cadastro-dados/auto-infracao",
        element: (
          <AnalistaRoute>
            <AutoDeInfracaoAnalista />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/cadastro-dados/taxas-checklist",
        element: (
          <AnalistaRoute>
            <TaxasChecklist />
          </AnalistaRoute>
        ),
      },
      {
        path: "/secretario/dashboard",
        element: (
          <SecretarioRoute>
            <SecretarioDashboard />
          </SecretarioRoute>
        ),
      },
      {
        path: "/secretario/solicitacao/:id",
        element: (
          <SecretarioRoute>
            <DetalheSolicitacaoSecretario />
          </SecretarioRoute>
        ),
      },
      {
        path: "/autorizacoes",
        element: (
          <PrivateRoute>
            <MinhasAutorizacoes />
          </PrivateRoute>
        ),
      },
      {
        path: "/nova-autorizacao",
        element: (
          <PrivateRoute>
            <NovaAutorizacao />
          </PrivateRoute>
        ),
      },
      {
        path: "/autorizacao/:id",
        element: (
          <PrivateRoute>
            <DetalheAutorizacao />
          </PrivateRoute>
        ),
      },
      {
        path: "/autorizacao/:id/emitir",
        element: (
          <SecretarioOuAnalistaRoute>
            <EmitirAutorizacao />
          </SecretarioOuAnalistaRoute>
        ),
      },
      {
        path: "/analista/checklist-autorizacao",
        element: (
          <AnalistaRoute>
            <AdicionarChecklistAutorizacao />
          </AnalistaRoute>
        ),
      },
      {
        path: "/analista/autorizacao-independente",
        element: (
          <SecretarioOuAnalistaRoute>
            <CriarAutorizacaoIndependente />
          </SecretarioOuAnalistaRoute>
        ),
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default router;
